import { Option, Select } from '@xo-union/tk-component-fields';
import { FieldProps, FormikErrors, getIn } from 'formik';
import moment from 'moment';
import React, { useMemo } from 'react';

import styles from './timeDropdown.scss';

interface Props extends FieldProps {
  label: string;
  // @ts-ignore
  setFieldValue: (field, value) => void;
}

export const TimeDropdown: React.FC<Props> = ({ field, form: { touched, errors }, label, setFieldValue, ...rest }) => {
  const { name, value } = field;

  const times = useMemo(() => {
    const day = moment.utc().startOf('day');
    const endOfDay = moment.utc().endOf('day');
    const fifteenMin = moment.duration(15, 'm');
    const morning: any = [];
    const afternoon: any = [];

    for (let i = 0; day < endOfDay; i += 1) {
      const formatedTime = day.format('h:mm A');
      // eslint-disable-next-line
      formatedTime.includes('AM') ? morning.push(formatedTime) : afternoon.push(formatedTime);
      day.add(fifteenMin);
    }
    return afternoon.concat(morning);
  }, []);

  // @ts-ignore
  const timeChangeHandler = (e): void => {
    const { value: val } = e.option;
    let formattedTime;
    if (val) {
      formattedTime = moment.utc(val, 'h:mm A').format('HH:mm');
    }
    setFieldValue(name, formattedTime);
  };

  let text: string | FormikErrors<any> | undefined;
  const fieldTouched = getIn(touched, field.name);
  const error = getIn(errors, field.name);

  if (fieldTouched && error) {
    text = error;
  }

  return (
    <Select
      name={name}
      value={moment.utc(value, 'HH:mm').format('h:mm A')}
      data-testid="time-dropdown"
      label={label}
      onChange={timeChangeHandler}
      state={fieldTouched && error ? 'invalid' : 'neutral'}
      subText={text}
      {...rest}
    >
      <div className={styles.blank}>
        <Option label="Select a Time" key="blank-time" value={null} />
      </div>
      {times.map((time: any) => (
        <Option key={time} value={time} />
      ))}
    </Select>
  );
};
